import React from 'react'
import CalloutSection from '../../UI/CalloutSection/CalloutSection'
import image from '../../../assets/images/community-message.jpg'
import classes from './CommunityMessage.module.css'

const CommunityMessage = (props) => (
  <CalloutSection
    image={image}
    alt="Aerial view of Carlisle, PA"
  >
    <p className={classes.Message}>
    Carlisle is a picturesque college town in striking distance of Philadelphia and Washington, D.C. (each two hours away) and New York City (three hours). In other words, to get away from it all for four years of college, you don’t have to live in the middle of nowhere.
    </p>
  </CalloutSection>
)

export default CommunityMessage

